import { memo } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useGlobalStore } from '../../../store/global-store'
import { Toast } from './components/toast'
import { useUpdateToastRocketGame } from './use-update-toast-rocket-game'

export const ToastRocketGame = memo(() => {
  useUpdateToastRocketGame()

  const notifyRocketGame = useGlobalStore(
    useShallow((state) => state.notifyRocketGame),
  )

  return (
    <div className="w-screen h-screen flex justify-center items-center flex-col gap-2">
      {notifyRocketGame?.map(
        (toast, index) => index === 0 && <Toast key={toast.id} toast={toast} />,
      )}
    </div>
  )
})
